import { IssueOrServiceType } from "~/app/data/statuses/chat";
import { SearchUser } from "~/types";

export interface WorkOrder {
    id: string;
    machineId: string;
    machineName: string;
    machineIntern: string;
    responsible: string;
    status: WorkOrderStatuses;
    issueCount: number;
    workOrderNo: string;
    workOrderStartDate: string;
    workOrderEndDate: string;
    createdAt: string;
    updatedAt: string;
}

export interface WorkOrderDetailResponse {
    result: string;
    data: WorkOrderDetail;
}

export interface WorkOrderDetail {
    id: number;
    history: WorkOrderHistory[];
    workOrderNo: string;
    lastUpdated: {
        date: string | null;
        name: string | null;
    },
    status: number;
    statusInfo: {
        comment: string | null;
        statusAt: string | null;
        statusBy: string | null;
    },
    isStarted: boolean;
    excavator: Excavator;
    operatingTime: number | null;
    operatingCount: number | null;
    createdBy: UserReference;
    approvedBy: UserReference;
    personnel: UserReference;
    mechanics: UserReference[];
    workType: number;
    repairLocation: string;
    costCategoryId: number | null;
    departmentId: number | null;
    chargedDepartmentId: number | null;
    customerId: number | null;
    projectId: number | null;
    sortingType: string | null;
    invoiceAcceptanceUser: string | null;
    scheduledStartDate: string;
    scheduledEndDate: string;
    actualStartDate: string | null;
    actualEndDate: string | null;
    description: string;
    comment: string;
    attachments: Attachment[];
    tasks: WorkOrderTask[];
    summary: WorkOrderSummary;
    parts: WorkOrderTaskPartList[];
    materials: WorkOrderTaskMaterialList[];
}

export interface WorkOrderSummary {
    totalHours: number;
    totalMaterials: number;
}

export interface WorkOrderTask {
    id: number;
    title: string;
    type: IssueOrServiceType;
    status: WorkOrderTaskStatus;
}

export interface WorkOrderTaskDetail {
    id: number;
    title: string;
    type: IssueOrServiceType;
    status: WorkOrderTaskStatus;
    description: string;
    users: WorkOrderTaskUserList[];
    parts: WorkOrderTaskPartList[];
    materials: WorkOrderTaskMaterialList[];
    attachments: Attachment[];
}

export interface WorkOrderTaskDetailPayload {
    id: number;
    taskId: number;
    type: IssueOrServiceType;
}

export interface WorkOrderTaskDetailResponse {
    result: string;
    data: WorkOrderTaskDetail;
}

export interface WorkOrderTaskMaterialList {
    id: number;
    name: string;
    quantity: number;
    type: IssueOrServiceType;
    issueId: number;
}

export interface WorkOrderTaskPartList {
    id: number;
    name: string;
    quantity: number;
    type: IssueOrServiceType;
    issueId: number;
}

export interface WorkOrderTaskUserList {
    id: number;
    name: string;
    ordinaryHours: number;
    overTime50: number;
    overTime100: number;
    hoursLogDate: string
}

export enum WorkOrderTaskStatus {
    INCOMPLETE = 0,
    COMPLETED = 1,
    REMOVED = 2,
}

export interface WorkOrderHistory {
    id: number;
    user: string;
    status: number;
    type: number;
    logValue: string | null;
    createdAt: string;
}

export interface Excavator {
    id: number;
    name: string;
    intern: string;
    isOperatingTimeVisible: number;
    operatingTimeAllowed: number;
    isOperatingCountVisible: number;
    operatingCountAllowed: number;
}

export interface UserReference {
    id: number;
    name: string;
}

export interface Attachment {
    id: number;
    name: string;
    url: string;
    mimeType: string;
}

export interface WorkOrderHistoryPayload {
    offset: number;
    machineId: string | null;
    filters: FilterWorkOrderPayload;
}

export interface WorkOrderHistoryResponse {
    data: WorkOrder[],
    result: boolean;
    message: string;
}

export interface WorkOrderGeneralSettings {
    hoursCount: number;
    plannedStartDate: string;
    plannedEndDate: string;
}

export interface WorkOrderExcavatorTaskListResponse {
    data: WorkOrderExcavatorTask[],
    result: boolean;
    message: string;
}

export interface WorkOrderExcavatorTask {
    id: number;
    type: IssueOrServiceType;
    title: string;
    description: string;
    date: string;
    serviceIntervalId?: number;
}

export interface CreateWorkOrderPayload {
    machineId: string;
    departmentId: number;
    responsibleId: number;
    plannedStartDate: string;
    plannedEndDate: string;
    description: string;
    tasks: WorkOrderExcavatorTask[];
}

export interface CreateWorkOrderResponse {
    result: 'success' | 'error';
    message: string;
    workOrderId: string;
}

export interface WorkOrderDepartment {
    id: number;
    name: string;
    hasCostCategory: boolean
    users: SearchUser[]
};

export interface FilterWorkOrderPayload {
    searchText: string;
    type: WorkOrderHistoryPayloadType;
    departments: string[];
    status: string[];
}

export enum WorkOrderStatuses {
    OPEN = 0,
    PLANNED = 1,
    DELAYED = 2,
    INPROGRESS = 3,
    ONHOLD = 4,
    FINISHED = 5,
    APPROVED = 6,
    CANCELLED = 7,
    NOTAPPROVED = 8
}

export const WorkOrderStatusesList = [WorkOrderStatuses.OPEN, WorkOrderStatuses.PLANNED, WorkOrderStatuses.DELAYED, WorkOrderStatuses.INPROGRESS, WorkOrderStatuses.ONHOLD, WorkOrderStatuses.FINISHED, WorkOrderStatuses.APPROVED, WorkOrderStatuses.CANCELLED, WorkOrderStatuses.NOTAPPROVED];

export interface WorkOrderFilterOption {
    id: string
    name: string
}
export interface WorkOrderFilterOptions {
    status: WorkOrderFilterOption[]
}

export enum WorkOrderHistoryPayloadType {
    MINE = 1,
    ALL = 0,
}

export interface CreateWorkOrderFormValues {
    machineId: string | number;
    departmentId: number;
    responsibleId: number;
    plannedStartDate: string;
    plannedEndDate: string;
    description: string;
}